function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M35.6,0c0.4,0,0.8,0.2,1.1,0.5c0.6,0.6,0.7,1.7,0,2.3L4.5,36.1l32.3,33.4c0.6,0.6,0.6,1.7,0,2.3c-0.6,0.6-1.7,0.6-2.3,0 L0,36.1L34.4,0.5C34.8,0.2,35.2,0,35.6,0z"
})), React.createElement("g", null, React.createElement("path", {
  d: "M3,34.5h92.7c0.9,0,1.6,0.7,1.6,1.6s-0.7,1.6-1.6,1.6H3c-0.9,0-1.6-0.7-1.6-1.6S2.1,34.5,3,34.5z"
})));

var SvgArrowLeft = function SvgArrowLeft(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 97.3 72.3",
    style: {
      enableBackground: "new 0 0 97.3 72.3"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/arrow-left.57bca502.svg";
export { SvgArrowLeft as ReactComponent };